(() => {
  if (!/\/products\//.test(location.pathname)) return;

  const el = (tag, className, parent) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (parent) parent.appendChild(node);
    return node;
  };

  const init = () => {
    const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    const mainSubmit = productInfo && productInfo.querySelector('.product-form__submit');
    const form = productInfo && productInfo.querySelector('form[action*="/cart/add"]');
    if (!productInfo || !mainSubmit || !form) return;

    const strings = window.variantStrings || {};
    const addLabel = strings.addToCart || 'Add to cart';
    const soldOutLabel = strings.soldOut || 'Sold out';
    const unavailableLabel = strings.unavailable || 'Unavailable';

    const bar = el('div');
    bar.id = 'cove-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.setAttribute('aria-hidden', 'true');
    const inner = el('div', 'cove-satc__inner', bar);
    const thumb = el('img', 'cove-satc__thumb', inner);
    thumb.alt = '';
    thumb.width = 48;
    thumb.height = 48;
    thumb.loading = 'lazy';
    const meta = el('div', 'cove-satc__meta', inner);
    const titleEl = el('p', 'cove-satc__title', meta);
    const sub = el('p', 'cove-satc__sub', meta);
    const priceEl = el('span', 'cove-satc__price', sub);
    const optionsEl = el('span', 'cove-satc__options', sub);
    const cta = el('button', 'cove-satc__cta', inner);
    cta.type = 'button';
    cta.tabIndex = -1;
    const ctaText = el('span', '', cta);
    document.body.appendChild(bar);

    const money = (cents) => '$' + (cents / 100).toFixed(2);
    const sized = (src, w) => {
      if (!src) return '';
      const url = src.startsWith('//') ? 'https:' + src : src;
      return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
    };

    let busy = false;
    let restoreTimer = null;
    let product = null;
    const variantsById = {};

    const currentVariant = () => {
      const idInput = form.querySelector('[name="id"]');
      return idInput ? variantsById[idInput.value] : undefined;
    };

    const setCta = (label, disabled, isBusy) => {
      ctaText.textContent = label;
      cta.disabled = !!disabled;
      cta.classList.toggle('is-busy', !!isBusy);
    };

    const syncCtaToVariant = (v) => {
      if (!v) setCta(unavailableLabel, true);
      else if (!v.available) setCta(soldOutLabel, true);
      else setCta(addLabel, false);
    };

    const render = (variant) => {
      if (!product) return;
      titleEl.textContent = product.title;
      thumb.alt = product.title;
      const v = variant || null;
      const imgSrc = (v && v.featured_image && v.featured_image.src) || product.featured_image;
      const nextSrc = sized(imgSrc, 96);
      if (nextSrc && thumb.src !== nextSrc) thumb.src = nextSrc;
      optionsEl.textContent = v && v.title !== 'Default Title' ? v.options.join(' / ') : '';
      if (v) {
        priceEl.textContent = money(v.price);
        bar.classList.toggle('cove-satc--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
      } else {
        priceEl.textContent = '';
      }
      if (!busy) syncCtaToVariant(v);
    };

    const settle = (added) => {
      if (!busy) return;
      clearTimeout(restoreTimer);
      busy = false;
      if (added) {
        setCta('Added ✓', true, true);
        restoreTimer = setTimeout(() => syncCtaToVariant(currentVariant()), 1400);
      } else {
        syncCtaToVariant(currentVariant());
      }
    };

    cta.addEventListener('click', () => {
      if (cta.disabled || busy || mainSubmit.hasAttribute('disabled')) return;
      busy = true;
      setCta('Adding…', true, true);
      mainSubmit.click();
      restoreTimer = setTimeout(() => settle(true), 2500);
    });

    let barH = 0;
    let observer = null;
    let shown = false;

    const setShown = (next) => {
      if (shown === next) return;
      shown = next;
      bar.setAttribute('aria-hidden', next ? 'false' : 'true');
      document.documentElement.classList.toggle('cove-atcbar-visible', next);
      cta.tabIndex = next ? 0 : -1;
    };

    // Southern Tide tri-state: hidden while the real ATC is on screen OR still below the fold; shown only once it's scrolled past the top.
    const syncVisibility = () => {
      const r = mainSubmit.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight - barH) return setShown(false);
      setShown(r.bottom <= 0);
    };

    const buildObserver = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(syncVisibility, {
        root: null,
        threshold: 0,
        rootMargin: `0px 0px -${barH}px 0px`,
      });
      observer.observe(mainSubmit);
    };

    const start = () => {
      barH = bar.offsetHeight;
      new ResizeObserver(() => {
        const h = bar.offsetHeight;
        if (h !== barH) {
          barH = h;
          buildObserver();
        }
        syncVisibility();
      }).observe(bar);
      buildObserver();
      // scroll fallback because some embedded webviews throttle IO callbacks
      let scrollTimer = null;
      window.addEventListener(
        'scroll',
        () => {
          if (scrollTimer) return;
          scrollTimer = setTimeout(() => {
            scrollTimer = null;
            syncVisibility();
          }, 90);
        },
        { passive: true }
      );
      syncVisibility();
    };

    if (typeof subscribe === 'function') {
      const EV = window.PUB_SUB_EVENTS || {};
      subscribe(EV.variantChange || 'variant-change', (e) => {
        const v = e && e.data && e.data.variant;
        render(v ? variantsById[v.id] || v : null);
      });
      subscribe(EV.cartUpdate || 'cart-update', () => settle(true));
      subscribe(EV.cartError || 'cart-error', () => settle(false));
    }

    fetch(location.pathname + '.js')
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => {
        if (!p || !p.variants) return;
        product = p;
        p.variants.forEach((v) => (variantsById[v.id] = v));
        render(currentVariant());
        start();
      })
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
